import React, { FC } from 'react';
import { FilesList } from '@shared/UI';
import { useModal } from '@features/Modal';
import { EDocsModal } from './components';

interface IEDocsProps {
    clearingAccount: string;
}

export const EDocs: FC<IEDocsProps> = ({ clearingAccount }) => {
    const { open } = useModal(EDocsModal);

    const onFileClick = (file: string) => {
        open({ file, clearingAccount });
    };

    return (
        <FilesList
            title={'E-Docs'}
            files={['Trade Confirmations', 'Account Statements', '1099 Composite', '1099-B', '1099-DIV']}
            onFileClick={(file) => onFileClick(file)}
        />
    );
};
